module.exports = __webpack_public_path__ + "static/media/DMG.54190266.svg";